module.exports = __webpack_public_path__ + "static/media/PCN-2024-8-20-01-LW02.c76594c9.pdf";